import { RootState } from 'editor/src/store/index';

const getSelectedSceneId = (state: RootState) => state.mockup.scenes.selectedSceneId;

export default getSelectedSceneId;
